var map = {
	"./de_DE.json": [
		24261,
		4261
	],
	"./en.json": [
		28211,
		8211
	],
	"./es_LA.json": [
		7480,
		7480
	],
	"./fr_FR.json": [
		14299,
		4299
	],
	"./it_IT.json": [
		80057,
		57
	],
	"./ja_JP.json": [
		24442,
		4442
	],
	"./pl_PL.json": [
		1143,
		1143
	],
	"./pt_PT.json": [
		75671,
		5671
	],
	"./tr_TR.json": [
		95359,
		5359
	],
	"./variant-21-en.json": [
		833,
		833
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 23462;
module.exports = webpackAsyncContext;